import React from "react";
import {
  Typography, Grid, Accordion, AccordionSummary,
  AccordionDetails, FormControl, InputLabel, Select, MenuItem
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SelectConAggiunta from "../SelectConAggiunta";

export default function SezionePiattaforma({ form, handleChange, tecnologie, loadingTecnologie, aggiungiTecnologia, piattaformeStudio, loadingStudio, aggiungiStudio, piattaformeDistr, loadingDistr, aggiungiDistr }) {
  return (
    <Accordion defaultExpanded elevation={1} sx={{ mb: 2 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: "#EEEDFE" }}>
        <Typography fontWeight="bold">Piattaforma</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2} mt={0}>
          <Grid item xs={12}>
            <SelectConAggiunta label="Tecnologia" value={form.tecnologie || []}
              onChange={(v) => handleChange("tecnologie", v)}
              items={tecnologie} loading={loadingTecnologie}
              onAggiungi={aggiungiTecnologia} multiple />
          </Grid>
          <Grid item xs={12} md={6}>
            <SelectConAggiunta label="Piattaforma studio" value={form.piattaformaStudio || ""}
              onChange={(v) => handleChange("piattaformaStudio", v)}
              items={piattaformeStudio} loading={loadingStudio}
              onAggiungi={aggiungiStudio} />
          </Grid>
          <Grid item xs={12} md={6}>
            <SelectConAggiunta label="Piattaforma distribuzione" value={form.piattaformaDistribuzione || ""}
              onChange={(v) => handleChange("piattaformaDistribuzione", v)}
              items={piattaformeDistr} loading={loadingDistr}
              onAggiungi={aggiungiDistr} />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Tenant da utilizzare</InputLabel>
              <Select value={form.tenant || ""} label="Tenant da utilizzare"
                onChange={(e) => handleChange("tenant", e.target.value)}>
                <MenuItem value="cliente">Cliente</MenuItem>
                <MenuItem value="algores">Algores</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}